// var tl = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".two",
//         start: "0% 95%",
//         end: "50% 50%",
//         scrub: true,

//     }
// })

// tl.to("#fanta", {
//     top: "100%",
//     rotate: "0deg",
//     left: "0",
//     scale: '1',
//     xPercent: -0,
// }, 'orange')
// tl.to("#orange-cut", {
//     top: "160%",
//     left: "23%"
// }, 'orange')
// tl.to("#orange", {
//     width: "15%",
//     top: "160%",
//     right: "10%"
// }, 'orange')
// tl.to("#leaf", {
//     top: "110%",
//     rotate: "130deg",
//     left: "70%"
// }, 'orange')
// tl.to("#leaf2", {
//     top: "110%",
//     rotate: "130deg",
//     left: "0%"
// }, 'orange')


// var tl2 = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".seven",
//         start: "0% 95%",
//         end: "20% 50%",
//         scrub: true,

//     }
// })

// tl2.from(".lemon1", {
//     rotate: "-90deg",
//     left: "-100%",
//     top: "110%"
// }, 'ca')
// tl2.from("#cocacola", {
//     rotate: "-90deg",
//     top: "110%",
//     left: "-100%",
// }, 'ca')

// tl2.from(".lemon2", {
//     rotate: "90deg",
//     left: "100%",
//     top: "110%"
// }, 'ca')
// tl2.from("#pepsi", {
//     rotate: "90deg",
//     top: "110%",
//     left: "100%",
// }, 'ca')

// tl2.to("#orange-cut", {
//     width: "18%",
//     left: "42%",
//     top: "204%"
// }, 'ca')
// tl2.to("#fanta", {
//     width: "35%",
//     top: "100%",
//     left: "33%",
// }, 'ca')

// var tl3 = gsap.timeline({
//     scrollTrigger: {
//         trigger: ".seven",
//         start: "0% 95%",
//         end: "20% 50%",
//         scrub: true,

//     }
// })

// tl3.from(".lemon1", {
//     rotate: "-90deg",
//     left: "-100%",
//     top: "110%"
// }, 'ca')
// tl3.from("#cocacola", {
//     rotate: "-90deg",
//     top: "110%",
//     left: "-100%",
// }, 'ca')

// tl3.from(".lemon2", {
//     rotate: "90deg",
//     left: "100%",
//     top: "110%"
// }, 'ca')
// tl3.from("#pepsi", {
//     rotate: "90deg",
//     top: "110%",
//     left: "100%",
// }, 'ca')

// tl3.to("#orange-cut", {
//     width: "18%",
//     left: "42%",
//     top: "204%"
// }, 'ca')
// tl3.to("#fanta", {
//     width: "25%",
//     top: "220%",
//     left: "39%",
// }, 'ca')

document.addEventListener("DOMContentLoaded", () => {
    var orange_cut = document.getElementById("orange-cut");
    var leap = document.getElementById("leaf2");

    setTimeout(() => {
        if (orange_cut) {
            orange_cut.style.transform = "translateX(0)";
            orange_cut.style.transition = "transform 1s ease-in-out";
        }
    }, 500); // Delay of 500ms

    setTimeout(() => {
        if (leap) {
            leap.style.transform = "translateX(0)";
            leap.style.transition = "transform 1s ease-in-out";
        }
    }, 500); // Delay of 1000ms
});
gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();

mm.add({
    // Desktop
    isDesktop: "(min-width: 769px)",

    // Mobile
    isMobile: "(max-width: 768px)"
}, (context) => {
    let { isDesktop, isMobile } = context.conditions;

    // === Timeline for desktop ===
    if (isDesktop) {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".two-lxe",
                start: "0% 95%",
                end: "50% 50%",
                scrub: true,
            }
        });

        tl.to("#fanta", {
            top: "100%",
            rotate: "0deg",
            left: "0",
            scale: 1,
            xPercent: 0,
        }, 'orange')
            .to("#orange-cut", {
                top: "130%",
                left: "19%"
            }, 'orange')
            .to("#orange", {
                width: "15%",
                top: "160%",
                right: "10%"
            }, 'orange')
            .to("#leaf", {
                top: "110%",
                rotate: "130deg",
                left: "70%"
            }, 'orange')
            .to("#leaf2", {
                top: "110%",
                rotate: "130deg",
                left: "0%"
            }, 'orange');

        let tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: ".seven-lxe",
                start: "0% 95%",
                end: "20% 50%",
                scrub: true,
            }
        });

        tl2.from(".lemon1", {
            rotate: "-90deg",
            left: "-100%",
            top: "110%"
        }, 'ca')
            // .from("#cocacola", {
            //     rotate: "-90deg",
            //     top: "110%",
            //     left: "-100%",
            // }, 'ca')
            // .from(".lemon2", {
            //     rotate: "90deg",
            //     left: "100%",
            //     top: "110%"
            // }, 'ca')
            // .from("#pepsi", {
            //     rotate: "90deg",
            //     top: "110%",
            //     left: "100%",
            // }, 'ca')
            // .to("#orange-cut", {
            //     width: "18%",
            //     left: "42%",
            //     top: "204%"
            // }, 'ca')
            .to("#fanta", {
                width: "30%",
                top: "210%",
                left: "37%",
            }, 'ca');
    }

    // === Timeline for mobile ===
    if (isMobile) {
        let tlMobile = gsap.timeline({
            scrollTrigger: {
                trigger: ".two",
                start: "top center",
                end: "bottom center",
                scrub: true,
            }
        });



        // Keep bottle static on mobile
        gsap.set("#fanta", {
            top: "20%",
            left: "60%",
            width: "100%",
            rotate: "50deg",
            scale: 1,
        });
    }
});
// Hide #fanta when hovering over any card
document.querySelectorAll(".front-img-lxe").forEach(card => {
    card.addEventListener("mouseenter", () => {
        gsap.to("#fanta", {
            autoAlpha: 0, // Hides with opacity + visibility
            duration: 0.5,
            ease: "power2.out"
        });
    });

    card.addEventListener("mouseleave", () => {
        gsap.to("#fanta", {
            autoAlpha: 1, // Show again
            duration: 0.5,
            ease: "power2.out"
        });
    });
});


// gsap.registerPlugin(ScrollTrigger);

// const isMobile = window.innerWidth <= 768;

// if (isMobile) {



//     const tl = gsap.timeline();

//     tl.from("#orange-cut", {
//         duration: 1.5,
//         top: "150%",
//         left: "100%",
//         width: "0%",
//         opacity: 0,
//         ease: "power3.out"
//     })

//         .from("#leaf2", {
//             duration: 1.5,
//             top: "40%",
//             left: "20%",
//             width: "40%",

//             rotate: "180deg",
//             ease: "power3.out"
//         }, "-=1.2");
// }
